import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContentStageBlockKind,
  ContentStageCandidateQuery,
} from 'generated/graphql';
import { toVideoEmbedUrl } from 'helpers/videoEmbed';

type ContentStageBlock = NonNullable<
  ContentStageCandidateQuery['myRole']
>['contentStages'][number]['blocks'][number];

const ContentBlock: FC<{ block: ContentStageBlock }> = ({ block }) => {
  const { t } = useTranslation();

  if (block.kind === ContentStageBlockKind.Image) {
    if (!block.imageUrl) {
      return null;
    }
    return (
      <div className="RoleStageContent__Block RoleStageContent__Block--Image">
        <img src={block.imageUrl} alt="" />
      </div>
    );
  }

  if (block.kind === ContentStageBlockKind.Video) {
    const embedUrl = block.videoUrl ? toVideoEmbedUrl(block.videoUrl) : null;
    if (!embedUrl) {
      return null;
    }
    return (
      <div className="RoleStageContent__Block RoleStageContent__Block--Video">
        <iframe
          src={embedUrl}
          title={t('contentStage.videoTitle')}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="RoleStageContent__Block RoleStageContent__Block--Text">
      {block.title && (
        <h2 className="RoleStageContent__BlockTitle">{block.title}</h2>
      )}
      {block.paragraph && (
        <p className="RoleStageContent__BlockParagraph">{block.paragraph}</p>
      )}
    </div>
  );
};

export default ContentBlock;
